module.exports = __webpack_public_path__ + "static/media/alaa.5580118f.png";